import styled from 'styled-components';
import { typography } from '@/styles/helpers';

export const ScVipTransferSuccess = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 24px;

  & .content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    & .title {
      ${typography.body1regular};
      letter-spacing: 0.16px;
      text-transform: uppercase;
      font-weight: 700;
    }

    & .description {
      ${typography.body1regular};
      letter-spacing: 0;
      color: ${({ theme }) => theme.grayColor};
    }
  }
`;
